// extracted by mini-css-extract-plugin
module.exports = {"gold":"NobuNFT_gold__2_k9S","main":"NobuNFT_main__2vRl6"};